import type { ReactElement } from "react";

import { useSelector } from "react-redux";

import ActiveContactsRevealPanel from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactsTableActionsPanel/ActiveContactsRevealPanel/ActiveContactsRevealPanel";

import type { BaseActivatedPanelProps } from "../../../table-actions-panel/components/BaseActivatedPanel/types";
import {
    selectMultipleRevealIsInProgress,
    selectNotRevealedCount,
    selectSearchResults,
    selectSearchResultsAreFetching,
} from "../../store/selectors";
import type { ContactRevealByIdRequestDto } from "../../types/dto";

type ActiveContactsRevealPanelProps = BaseActivatedPanelProps & {
    onSubmit(topNOrIds: number | readonly ContactRevealByIdRequestDto[], onDone: () => void): void;
};

const ActiveContactsRevealPanelBaseContainer = (props: ActiveContactsRevealPanelProps): ReactElement => {
    const contacts = useSelector(selectSearchResults);
    const areSearchResultsFetching = useSelector(selectSearchResultsAreFetching);
    const notRevealedCount = useSelector(selectNotRevealedCount);
    const isMultipleRevealInProgress = useSelector(selectMultipleRevealIsInProgress);

    return (
        <ActiveContactsRevealPanel
            isLoading={isMultipleRevealInProgress}
            notRevealedCount={notRevealedCount || 0}
            contactsCount={contacts?.rows?.length || 0}
            areSearchResultsFetching={areSearchResultsFetching}
            {...props}
        />
    );
};

export default ActiveContactsRevealPanelBaseContainer;
